import HTTP from '../HTTP';

export default {
  getMaterials() {
    return HTTP.get('/materials');
  },
  save(data) {
    if (data.id) {
      delete data.can_be_changed;
      return HTTP.put(`/materials/${data.id}`, data);
    }
    return HTTP.post('/materials', data);
  },
  remove(id) {
    return HTTP.delete('/materials/', {
      data: {
        ids: [id]
      }
    });
  },
  saveOrder(credentials) {
    return HTTP.put(`/materials/${credentials.materialId}/move`, credentials);
  },
  changeVisibility(data) {
    return HTTP.put('/materials/hide', data);
  }
};